var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCassette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7917 6.41917C13.2874 6.41917 14.5 5.20661 14.5 3.71084C14.5 2.21506 13.2874 1.0025 11.7917 1.0025C10.2959 1.0025 9.08333 2.21506 9.08333 3.71084C9.08333 5.20661 10.2959 6.41917 11.7917 6.41917ZM11.7917 6.41917H4.20833M4.20833 6.41917C5.7041 6.41917 6.91667 5.20661 6.91667 3.71084C6.91667 2.21506 5.7041 1.0025 4.20833 1.0025C2.71256 1.0025 1.5 2.21506 1.5 3.71084C1.5 5.20661 2.71256 6.41917 4.20833 6.41917Z",
    stroke: "#9DA6B4",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCassette);
export default __webpack_public_path__ + "static/media/cassette.2bfba64a2c8d58db84dd684c71d6df86.svg";
export { ForwardRef as ReactComponent };